import React__default from 'react';
import { AkArrowRightIcon } from '@fuegokit/fuegoicons-react';
import { STATUSES } from './types.js';
import Box from '../Box/Box.js';
import AtlasLozenge from '../AtlasLozenge/AtlasLozenge.js';

/* eslint-disable @typescript-eslint/no-non-null-assertion */

/** Describes a transition */
const RuleTransition = ({
  fromStatus,
  targetStatus,
  testId,
  leadingElement,
  trailingElement,
  statusType
}) => {
  const fromLozengeTestId = `${testId}-from-lozenge`;
  const toLozengeTestId = `${testId}-to-lozenge`;
  const wrapperTestId = `${testId}-wrapper`;
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: statusType === 'transition' ? 2 : 1
    },
    "data-testid": testId ? wrapperTestId : 'undefined'
  }, fromStatus && !leadingElement &&
  /*#__PURE__*/
  // we will remove these lozenges in a future release;
  // we are only still including the `fromStatus` and `toStatus` props
  // because removing them would be a breaking change
  React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(AtlasLozenge, {
    appearance: fromStatus,
    testId: testId ? fromLozengeTestId : 'undefined'
  }, STATUSES[fromStatus])), leadingElement && !fromStatus && /*#__PURE__*/React__default.createElement(Box, null, leadingElement), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      color: 'icon.default'
    }
  }, statusType === 'transition' && /*#__PURE__*/React__default.createElement(AkArrowRightIcon, null), statusType === 'equal' && /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 4,
      fontWeight: 'bold',
      height: '24px',
      width: '24px'
    }
  }, "=")), trailingElement && !targetStatus && /*#__PURE__*/React__default.createElement(Box, null, trailingElement), targetStatus && !trailingElement && /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(AtlasLozenge, {
    appearance: targetStatus,
    testId: testId ? toLozengeTestId : 'undefined'
  }, STATUSES[targetStatus])));
};
RuleTransition.displayName = "RuleTransition";
var RuleTransition$1 = RuleTransition;

export { RuleTransition$1 as default };
